import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import { blue } from '~theme';

const Spinner = props => (
  <Icon
    icon={faSpinner}
    className={props.className}
    size={props.size}
    color={props.color}
  />
);

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Icon = styled(FontAwesomeIcon)`
  && {
    font-size: ${p => (p.size ? `${p.size}px` : '32px')};
  }
  color: ${p => p.color || blue};
  animation: ${rotate} 1s linear infinite;
  margin: 6px;
`;

export default Spinner;
